import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvoiceService } from '../../../../services/invoice.service';
import { AppointmentService } from '../../../../services/appoinment.service';
import { ClientService } from '../../../../services/client.service';
import { ManagerialService } from '../../../../services/managerial.service';
import { PetService } from '../../../../services/pet.service';
import { CatalogService } from '../../../../services/catalog.service';
import { SetupService } from '../../../../services/setup.service';
import { ProcedureService } from '../../../../services/procedure.service';
import { SharedService } from '../../../../services/shared.service';
import { MenuService } from '../../../../services/menu.service';
import { PetToInvoiceModel } from "../../../../models/invoice-model";
import { PaymentDetailsModel } from "../../../../models/invoice-model";
import { RabiesVaccineModel } from "../../../../models/rabies-vaccine.model";
import { TranRecordModel } from "../../../../models/tran-record.model";
import { DeleteATranModel } from "../../../../models/delete-a-tran.model";
import { InvHistoryModel } from "../../../../models/invoice-history.model";
import { EmailServiceModel } from "../../../../models/email-service.model";
import { encode_base64, encode_utf8 } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';
// import { PaymentService } from '../../../../services/payment.service';
import { EmailService } from '../../../../services/email.service';
import { Router, ActivatedRoute } from '@angular/router';
declare var $: any;


@Component({
  selector: 'ngx-inv-casgreg',
  templateUrl: './inv-casgreg.component.html'
})
export class InvCasgregComponent implements OnDestroy {
  private subscriptions: Subscription = new Subscription();


  client_no: number = 0
  clinic_no: number = 0


  selectedDiscount: any
  customDiscount: any = 0
  pet_to_invoice_index: number = 0
  initialTabActive: boolean = true;
  pet_to_invoice_item: any = []
  method_details = [];

  partial_change = 0

  payment_form: any = {
    amount: 0.00,
    method: '',
    method_dets: '',
    receiver: '',
    pet_no: 0
  }

  deletetran_question: any[] = []
  private postInvoiceResolve: (() => void) | null = null;

  methods: any = [{ method_no: 1, method_code: 'CASH' }, { method_no: 2, method_code: 'CHECK' }, { method_no: 3, method_code: 'CHARGE' },
  { method_no: 4, method_code: 'ATM' }, { method_no: 6, method_code: 'COUPON' },
  { method_no: 7, method_code: 'ACCOUNT' }, { method_no: 8, method_code: 'INSURANCE' },
  { method_no: 5, method_code: 'OTHER' }]

  constructor(
    public managerialService: ManagerialService,
    public setupService: SetupService,
    public invoiceService: InvoiceService,
    public appointmentService: AppointmentService,
    public clientService: ClientService,
    public petService: PetService,
    public catalogService: CatalogService,
    public procedureService: ProcedureService,
    public sharedService: SharedService,
    private httpClient: HttpClient,
    // private paymentService: PaymentService,
    public emailService: EmailService,
    public menuService: MenuService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.subscriptions.add(
      this.invoiceService.notifyPayRegObservable.subscribe(() => {
        this.inializePage();
      })
    );

    this.subscriptions.add(
      this.clientService.printInvoiceObservable.subscribe(() => {
        this.FinalizeInvoice();
      })
    );

    if (this.invoiceService.pet_to_invoice_list.length == 0) {
      this.router.navigate(['../invoice'], { relativeTo: this.route });
    }
  } 

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  } 
  async inializePage() {
    console.log('inializePageCashReg')
    Swal.fire({
      title: 'Loading...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    this.invoiceService.payment_forms = []
    this.client_no = this.clientService.current_client_no
    this.clinic_no = this.invoiceService.userData.clinic_no

    //From ngOnInit
    this.managerialService.getDiscount();
    this.setupService.GetCoupon(this.clinic_no);
    this.invoiceService.GetActiveRabiesVaccine()
    this.invoiceService.GetCityLicense(this.clinic_no)
    this.invoiceService.emailInvReciept = false


    let toAlert_Asso = [];
    let promises = [];

    this.invoiceService.payment_Details_list.forEach((item3) => {
      let promise = new Promise(async (resolve, reject) => {
        let assoc_other: any = await this.invoiceService.getAssociateByPetId(item3.pet_no);
        assoc_other.forEach((item_other) => {
          if (item_other.associate_no != this.client_no) {
            let new_balance = (item_other.associate_ownership / 100) * item3.total_charge;
            let assoc_total_tax = this.invoiceService.tax_rate * new_balance;

            this.invoiceService.assocother_forPetFinance.push({
              balance: new_balance + assoc_total_tax,
              client_no: item_other.associate_no,
              pet_no: item3.pet_no
            });
          }

          if (item_other.associate_no == this.client_no && item_other.pet_no == item3.pet_no && item_other.associate_ownership < 100) {
            toAlert_Asso.push(item3.pet_no);
            item3.total_charge = (item_other.associate_ownership / 100) * item3.total_charge;
            item3.ownership = item_other.associate_ownership;
          }
        });
        resolve(0);
      });
      promises.push(promise);
    });

    Promise.all(promises).then(() => {
      this.amountCalculationList();
      Swal.close();

      if (toAlert_Asso.length != 0) {
        Swal.fire({
          title: 'Partial Ownership Patient',
          text: toAlert_Asso.join(', ') + ' is NOT billed 100% to this client.',
          didOpen: () => { },
        });
      }
    }).catch((error) => {
      console.error('Error:', error);
    });



  }

  samp(){

  }

  async amountCalculationList() {
    this.invoiceService.payment_Details = new PaymentDetailsModel(null, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)
    this.partial_change = 0

    await this.invoiceService.payment_Details_list.forEach(async (item) => {
      console.log('item from payment_Details_list: ', item)
      const nonprofit = (this.invoiceService.currentClient_Nonprofit != true) ? 1 : 0;
      //console.log('nonprof:' + nonprofit + ', this: ' + this.clientService.client.nonprofit)

      const total_tax_ofCharge = (this.invoiceService.tax_rate * item.total_charge) * nonprofit
      let subtotal_charge = (item.total_charge + total_tax_ofCharge) - item.Discount

      const total_amount_paid = this.invoiceService.payment_forms.reduce((sum, itemform) => {
        if (itemform.pet_no == item.pet_no && !isNaN(itemform.amount) && itemform.method != 6 && itemform.method !== 7) {
          return sum + parseFloat(itemform.amount);
        }
        return sum;
      }, 0);

      const total_coupon = this.invoiceService.payment_forms.reduce((sum, itemform) => {
        if (itemform.pet_no == item.pet_no && !isNaN(itemform.amount) && itemform.method == 6) {
          return sum + parseFloat(itemform.amount);
        }
        return sum;
      }, 0);

      const total_clinic_account = this.invoiceService.payment_forms.reduce((sum, itemform) => {
        if (itemform.pet_no == item.pet_no && !isNaN(itemform.amount) && itemform.method == 7) {
          return sum + parseFloat(itemform.amount);
        }
        return sum;
      }, 0);

      const amount_paid = total_amount_paid;
      const coupon = total_coupon;
      const clinic_account = total_clinic_account;
      const total_Amount = Number(amount_paid) + Number(coupon) + Number(clinic_account)

      const balance_due = subtotal_charge + item.prior_balance - item.deposit

      const current_balance = balance_due - total_Amount

      item.balance_due = balance_due;
      item.total_tax = total_tax_ofCharge;

      //change the amount_paid to total_paid
      item.amount_paid = this.formatNum(total_Amount) - item.change;
      item.coupon = coupon;
      item.clinic_account = clinic_account;

      //get partial change  
      this.partial_change += (Math.sign(current_balance) == -1) ? current_balance * -1 : 0;
      item.current_balance = this.formatNum((current_balance + item.change))


      //Add all on the list 
      this.invoiceService.payment_Details.Discount += item.Discount
      this.invoiceService.payment_Details.actual_charge += item.actual_charge
      this.invoiceService.payment_Details.total_charge += subtotal_charge
      this.invoiceService.payment_Details.total_tax += total_tax_ofCharge
      this.invoiceService.payment_Details.prior_balance += item.prior_balance
      this.invoiceService.payment_Details.balance_due += item.balance_due
      this.invoiceService.payment_Details.amount_paid += Number(amount_paid)
      this.invoiceService.payment_Details.coupon += Number(coupon)
      this.invoiceService.payment_Details.clinic_account += Number(clinic_account)
      this.invoiceService.payment_Details.change += item.change
      this.invoiceService.payment_Details.current_balance += item.current_balance
    })


    this.partial_change = this.formatNum(this.partial_change)
  }

  calculateChange() {
    this.invoiceService.payment_Details_list.forEach(pet => {
      if (Math.sign(pet.current_balance) == -1) {
        //pet.amount_paid = pet.amount_paid + pet.current_balance
        pet.change = (pet.current_balance * -1)

      }
    })

    this.amountCalculationList()
  }


  changebtn_reset() {
    this.invoiceService.payment_Details_list.forEach(item => item.change = 0);
    this.amountCalculationList()
  }

  handleDiscountChange(discount_val) {
    if (discount_val == 'CD') {
      this.selectedDiscount = discount_val
      this.invoiceService.payment_Details_list.forEach((items) => {
        items.Discount = 0
        items.Discount = (this.customDiscount / 100) * items.total_charge;
      })
    }
    else {
      this.selectedDiscount = discount_val
      this.invoiceService.payment_Details_list.forEach((items) => {
        items.Discount = 0
        items.Discount = (this.selectedDiscount / 100) * items.total_charge;
      })
    }

    this.amountCalculationList()
  }

  checkPetDetailsTab(i, items) {
    this.pet_to_invoice_index = i
    this.initialTabActive = false
    this.pet_to_invoice_item = items

    this.payment_form.amount = (Math.sign(this.invoiceService.payment_Details_list[i].current_balance) == -1) ? 0 : this.invoiceService.payment_Details_list[i].current_balance;
  }

  checkPetDetailsTab_All() {
    this.initialTabActive = true
  }

  ReceivePayment() {
    if (this.payment_form.amount <= 0) {
      // Swal.fire({
      //     title: 'Enter Amount' 
      // })


      // return false
    }
    else if (this.payment_form.method == '') {
      Swal.fire({
        title: 'Enter Payment method'
      })
      return false
    }

    this.invoiceService.payment_forms.push({
      amount: this.payment_form.amount,
      method: this.payment_form.method,
      method_dets: this.payment_form.method_dets,
      receiver: this.payment_form.receiver,
      pet_no: this.pet_to_invoice_item.pet_no,
    });

    this.payment_form = {
      amount: 0.00,
      method: '',
      method_dets: '',
      receiver: '',
      pet_no: 0
    }
    //this.amountCalculation_All() 
    this.amountCalculationList()
  }

  deletePayment(index) {
    this.invoiceService.payment_forms.splice(index, 1);
    this.amountCalculationList()
  }

  fillMethodDetails(method) {
    if (method == 3) {
      this.method_details = [];
      const items = ['amex', 'care', 'disc', 'gift', 'mast', 'visa', 'scratchpay']
      items.forEach((item) => {
        this.method_details.push([item, item])
      });
    }
    else if (method == 6) {
      this.method_details = [];
      this.setupService.coupon.forEach((item) => {
        this.method_details.push([item.coupon_name, item.coupon_name])
      });
    }
    else {
      this.method_details = []
    }
  }

  setMethodCodeByNo(methodNo: number) {
    const method = this.methods.find((m: any) => m.method_no == methodNo);
    return method.method_code;
  }

  formatNum(thisnum) {
    return parseFloat(thisnum.toFixed(2));
  }

  //#region on click of FINALIZE INVOICE button

  async FinalizeInvoice() {
    if (this.invoiceService.payment_forms.length == 0) {
      Swal.fire({
        title: 'Error',
        text: 'No payment methods found',
        icon: 'error'
      })
      return
    }

    this.invoiceService.UpdateSequencer().then(() => {
      this.invoiceService.GetMaxNo_InvoiceNo().then((res: number) => {
        this.invoiceService.inv_otherdata.client_no = this.client_no;
        this.invoiceService.inv_otherdata.lngInvNo = res;
        this.invoiceService.inv_otherdata.clinic_no = this.clinic_no;

        this.invoiceService.AddToCashReg();

        this.invoiceService.saveInvoiceReceiptInfo().then((saveRes: number) => {
          if (saveRes == 1) {
            this.PutIntoHistory();
            this.runPostInvoiceActions().then(() => {
              this.processRabiesVaccine();
            });
          } else {
            Swal.fire({ title: 'Error', text: 'Failed to save invoice receipt info', icon: 'error' });
          }
        });
      });
    });


  }

  pets_with_rabies: { pet_no: number, pet_name: string, rabies_tag_no: string, altered_pet: string, city_license: number, neuter: number, rabies: number }[] = []
  processRabiesVaccine() {
    const matchingPets = this.invoiceService.compiled_PetINV.filter(pet =>
      this.invoiceService.payment_Details_list.some(paymentDetail => paymentDetail.pet_no == pet.pet_no)
    );

    matchingPets.forEach(item => {
      if (item.rabiesDets >= 1 || item.neuterDets >= 1) {
        this.pets_with_rabies.push({ pet_no: item.pet_no, pet_name: item.pet_name, rabies_tag_no: '', altered_pet: '', city_license: 0, neuter: item.neuterDets, rabies: item.rabiesDets })
      }
    })

    if (this.pets_with_rabies.length > 0) {
      this.openActiveRabiesVaccine()
    }
    else {
      this.backToHome();
    }

  }

  runPostInvoiceActions(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.postInvoiceResolve = resolve;
      this.deletetran_question = [];

      const deleteTranPromise = this.invoiceService.DeleteTran().then((items: any[]) => {
        this.deletetran_question = (items || []).map((t: any) => ({ ...t, selected: false }));
      });

      const invoice_no = this.invoiceService.inv_otherdata.lngInvNo;
      const dateParam = this.invoiceService.getCurrentDate();

      const afterInvoicePromise = this.invoiceService.GetDataAfterInvoice(invoice_no, dateParam).then((res: any[]) => {
        if (res && res.length > 0) {
          this.petToBeDeletedItems = res.map((element: any) => ({
            pet_no: element.pet_no ?? 0,
            pet_name: element.pet_name ?? '',
            sub_appt_id: element.sub_appt_id ?? 0,
            appointment_id: element.appointment_id ?? 0,
            tag_no: element.tag_no ?? '',
            selectedTag: !!element.tag_no,
            selectedAppt: !!element.sub_appt_id,
          }));

          this.petToBeDeletedItems.forEach((item: any) => {
            this.invoiceService.DeleteDataAfterInvoice(item.pet_no, this.invoiceService.getCurrentDate(), this.client_no);
          });
        } else {
          this.petToBeDeletedItems = [];
        }
      });

      Promise.all([deleteTranPromise, afterInvoicePromise]).then(() => {
        if (this.deletetran_question.length > 0 || this.hasAfterInvoiceItems) {
          $('#modalPostInvoice').modal('show');
        } else {
          if (this.postInvoiceResolve) { this.postInvoiceResolve(); this.postInvoiceResolve = null; }
        }
      }).catch(() => {
        if (this.postInvoiceResolve) { this.postInvoiceResolve(); this.postInvoiceResolve = null; }
      });
    });
  }

  get hasAfterInvoiceItems(): boolean {
    return this.petToBeDeletedItems.some((item: any) =>
      (item.tag_no && item.tag_no !== '') || (item.appointment_id && item.appointment_id > 0)
    );
  }

  async confirmPostInvoice() {
    const selectedTrans = this.deletetran_question.filter((item: any) => item.selected);

    if (selectedTrans.length > 0) {
      const treatmentItems = selectedTrans.filter((item: any) => item.status === 'T' || item.status === 'W');
      if (treatmentItems.length > 0) {
        const names = treatmentItems.map((item: any) => item.code_name).join(', ');
        const result = await Swal.fire({
          title: 'Delete Treatment',
          text: `Are you sure you want to permanently delete '${names}'?`,
          showCancelButton: true,
          confirmButtonText: 'Continue',
          cancelButtonText: 'Cancel'
        });
        if (!result.isConfirmed) return;
      }

      for (const item of selectedTrans) {
        this.invoiceService.DeleteATran(this.invoiceService.invtrans_formatter(item), 0, 1, item);
      }
    }

    const tasks: Promise<any>[] = [];
    this.petToBeDeletedItems.forEach((item: any) => {
      if (item.selectedTag && item.tag_no) {
        tasks.push(this.petService.SetupTagNo(0, item.tag_no, item.pet_no, '', '', 0, 0, this.petService.getCurrentDateTime(), 'I', ''));
      }
      if (item.selectedAppt && item.appointment_id) {
        tasks.push(this.appointmentService.UpdateApptSubStatus(item.sub_appt_id, 'I'));
      }
    });

    await Promise.all(tasks);

    $('#modalPostInvoice').modal('hide');
    if (this.postInvoiceResolve) { this.postInvoiceResolve(); this.postInvoiceResolve = null; }
  }

  dismissPostInvoiceModal() {
    $('#modalPostInvoice').modal('hide');
    if (this.postInvoiceResolve) { this.postInvoiceResolve(); this.postInvoiceResolve = null; }
  }

  async confirmRabiesVaccine() {
    const tasks = this.pets_with_rabies.map(async (item) => {
      if (item.neuter >= 1) {
        await this.invoiceService.UpdatePetNeuter(item.pet_no);
      }

      if (item.rabies >= 1) {
        await this.invoiceService.UpdateRabiesTagNo(item.pet_no, item.rabies_tag_no);
        await this.invoiceService.SetupMoveRabInfo(item.pet_no, this.clinic_no);
        this.printRabieCert(item.pet_no);
        if (this.invoiceService.activeClinicDetails.rabie_lic_city == 'FORT WORTH' && item.city_license != 0) {
          const amount = this.invoiceService.cityLicense.find(city => city.link_no == item.city_license).cert_cost
          this.printRabiesFtWorth(item.pet_no, amount)
        }
        else if (this.invoiceService.activeClinicDetails.rabie_lic_city == 'HOUSTON' && item.city_license != 0) {
          const amount = this.invoiceService.cityLicense.find(city => city.link_no == item.city_license).cert_cost
          this.printRabiesHouston(item.pet_no, amount)
        }

      }
    });

    await Promise.all(tasks).then(() => {
      $('#modalActiveRabiesVaccine').modal('hide')
      // this.router.navigate(['../invoice'], { relativeTo: this.route });
      this.backToHome();
    }).catch(err => console.error('Update failed', err));
  }

  printRabieCert(pet_no) {
    let $string = `admin` + "U*63r" + 'FPC_RabiesCertificate' + "R0d&3" + 'pdf' + "R3nd%" + '' + "Fr3n6" + `Rabies Certificate #${pet_no} ${new Date().getTime()}` + "T1*73";
    let $result = encode_utf8($string);
    $result = encode_base64($result);

    let $strfilter = `&pet_no=${pet_no}&clinic_no=${this.clinic_no}&blnReprint=False`;

    let url = `https://ssrs.itimpact.com/fpc_ssrs/default.aspx?token=${$result}${$strfilter}`;

    window.open(url, '_blank', 'popup=yes');
  }

  printRabiesFtWorth(pet_no, amount) {
    let $string = `admin` + "U*63r" + 'FPC_RabiesFtWorth' + "R0d&3" + 'pdf' + "R3nd%" + '' + "Fr3n6" + `Pet License(Fort Worth) #${pet_no} ${new Date().getTime()}` + "T1*73";
    let $result = encode_utf8($string);
    $result = encode_base64($result);

    let $strfilter = `&pet_no=${pet_no}&clinic_no=${this.clinic_no}&blnReprint=False&sglAmount=${amount}`;

    let url = `https://ssrs.itimpact.com/fpc_ssrs/default.aspx?token=${$result}${$strfilter}`;

    window.open(url, '_blank', 'popup=yes');
  }

  printRabiesHouston(pet_no, amount) {
    let $string = `admin` + "U*63r" + 'FPC_RabiesFtWorth' + "R0d&3" + 'pdf' + "R3nd%" + '' + "Fr3n6" + `Pet License(Fort Worth) #${pet_no} ${new Date().getTime()}` + "T1*73";
    let $result = encode_utf8($string);
    $result = encode_base64($result);

    let $strfilter = `&pet_no=${pet_no}&clinic_no=${this.clinic_no}&blnReprint=False&sglAmount=${amount}`;

    let url = `https://ssrs.itimpact.com/fpc_ssrs/default.aspx?token=${$result}${$strfilter}`;

    window.open(url, '_blank', 'popup=yes');
  }

  // printInvoiceReceipt(clinic_no, client_no, invoice_no) {
  //   let $string = `admin` + "U*63r" + 'FPC_InvoiceReceipt' + "R0d&3" + 'pdf' + "R3nd%" + '' + "Fr3n6" + `Invoice Receipt. ${new Date().getTime()}` + "T1*73";
  //   let $result = encode_utf8($string);
  //   $result = encode_base64($result);

  //   let $strfilter = `&clinic_no=${clinic_no}&client_no=${client_no}&invoice_no=${invoice_no}&pet_no=0`;

  //   let url = `https://ssrs.itimpact.com/fpc_ssrs/default.aspx?token=${$result}${$strfilter}`;

  //   window.open(url, '_self', 'visible=none');
  // }

  petToBeDeletedItems: any[] = []

  //#endregion

  //#region Email Invoice to Client
  openEmailModal() {
    this.emailService.openEmailModal({
      from: this.invoiceService.userData.email,
      to: this.clientService.client.email_address,
      subject: 'Your Invoice from FamilyPetCare',
      body: this.billSummary(),
      attachmentPath: { fileName: '', contentType: '', data: '' }
    })
    //this.createPaymentLink() 
  }


  createPaymentItems() {
    let items = []
    this.invoiceService.payment_Details_list.forEach((item) => {
      this.invoiceService.compiled_PetINV.forEach((pet) => {
        if (pet.pet_no == item.pet_no) {
          pet.procsDetails.done.forEach((proc) => {
            items.push({ tran_sequence: proc.tran_sequence, description: proc.desc, amount: proc.amount })
          })
          // pet.procsDetails.undone.forEach((proc) => {
          //   items.push({tran_sequence: proc.tran_sequence, description: proc.desc, amount: proc.amount})
          // }) 
        }
      })
    });

    return items
  }

  billSummary() {
    let billSummary = ''
    this.invoiceService.payment_Details_list.forEach((item) => {
      let pet = this.invoiceService.pet_to_invoice_list.find(pet => pet.pet_no == item.pet_no);
      billSummary += `Pet Name: ${pet.pet_name} \n` +
        `Total Charge: ${item.total_charge} \n` +
        `Discount: ${item.Discount} \n` +
        `Total Tax: ${item.total_tax} \n` +
        `Prior Balance: ${item.prior_balance} \n` +
        `Deposit: ${item.deposit} \n` +
        `Balance Due: ${item.balance_due} \n` +
        `Total Balance: ${item.current_balance} \n\n`
    });

    return billSummary
  }

  //#endregion

  //#region Payment Link

  // createPaymentLink(){
  //   Swal.fire({
  //     title: 'Loading...',
  //     timerProgressBar: true,
  //     didOpen: () => {
  //       Swal.showLoading()
  //     },
  //   })

  //   this.invoiceService.payment_service = {CustomerEmail: this.invoiceService.userData.email, Description: 'Payment for Invoice', Amount: (this.invoiceService.payment_Details.current_balance * 100)}
  //   this.invoiceService.CreateAndSendInvoice().then((res:string) => {  
  //   })
  // }

  getHostedToken() {
    // this.paymentService.getHostedToken(100).then((res: any) => {
    //   console.log('Hosted Token:', res)
    //   this.sendEmail(res)
    // })
  }

  sendEmail(token: string) {
    const paymentUrl = `https://test.authorize.net/payment/payment`;
    const billSummaryHtml = this.billSummary().replace(/\n/g, '<br/>');
    const buttonHtml = `
<form method='post' action=''>
    <input type='hidden' name='token' value='${token}' />
    
    <button 
        type='submit' 
        style="
            /* Color and Background */
            background-color: #007bff; 
            color: #ffffff;
            
            /* Spacing and Shape */
            padding: 12px 20px;
            border: none; /* Remove default border */
            border-radius: 5px;
            
            /* Font and Display */
            font-size: 16px;
            text-decoration: none; /* Good practice, even though buttons don't underline */
            display: inline-block;
            cursor: pointer; /* Ensures mouse cursor indicates it's clickable */
        "
    >
        Manage My Payment Profiles
    </button>
</form>
<p style="font-size:12px;color:#777;margin-top:10px;">If the button doesn’t work, copy and paste this link into your browser:<br/>${paymentUrl}</p>`;

    this.emailService.email_service.From = this.invoiceService.userData.email
    this.emailService.email_service.To = this.clientService.client.email_address || ''
    this.emailService.email_service.Subject = 'Your Invoice from FamilyPetCare'
    this.emailService.email_service.AttachmentPath = ''
    this.emailService.email_service.Body =
      `<p>Dear ${this.clientService.client.first_name},</p>` +
      `<p>Thank you for trusting [Pet Clinic Name] with the care of your beloved pet.</p>` +
      `<p>Please find below the detailed breakdown of the charges:</p>` +

      `<div>${billSummaryHtml}</div>` +

      `<p>To view your detailed invoice and to make a secure payment,</p>` +

      `${buttonHtml}` +

      `<p>If you have any questions regarding this invoice, please don't hesitate to contact us at [Clinic's Contact Information].</p>` +
      `<p>Thank you for your prompt attention to this matter.</p>` +
      `<p>Best regards,</p>`;
    this.emailService.email_service.isHtml = true;
    Swal.close();

    $('#modalEmail').modal('show')
  }
  //#endregion 

  //#region Moving Transaction to History
  PutIntoHistory() {
    this.invoiceService.invoice_trans.forEach((trans_item) => {
      this.invoiceService.pet_to_invoice_list.forEach((checkitem) => {
        if (trans_item.pet_no == checkitem.pet_no) {
          if (trans_item.sup_sequence == 0) {
            if (trans_item.status == 'D' || trans_item.status == 'F' || trans_item.status == 'O') {
              this.MoveToHistoryParent(trans_item)
            }
            else {
              this.MoveToSuggested(trans_item)
            }
          }
          else if (trans_item.status == 'S') {
            this.MoveToSuggested(trans_item)
          }
        }
      })
    });
  }

  MoveToHistoryParent(tran): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      if (tran.moved == 1) {
        resolve(true)
      }

      const lngHistSeq = await this.MoveToHistoryProc(tran, 0)
      if (lngHistSeq != 0) {
        tran.moved = 1

        this.invoiceService.UpdateTransMoved(tran.tran_sequence)

        if (tran.code_name == 'EUTH') {
          if (this.clinic_no == 1) {
            this.invoiceService.UpdateEuthToInactive(tran.pet_no)
          }
        }

        this.UpdateBriefHist(tran)
        this.MoveToDrugNote(tran)
        this.MoveToHistoryChild(tran, lngHistSeq)

        let strSubCat = await this.invoiceService.GetItemCategory(1459, 0, 1).then((res: any) => { return res.code_sub_category })
        if (strSubCat == 'O-LAB') {
          this.invoiceService.InsertLabTran(lngHistSeq, tran.pet_no, tran.code_clinic, tran.done_date, tran.link_no, tran.link_type, tran.appr_by)
        }

        this.MoveSubTran(tran.tran_sequence, lngHistSeq)
        resolve(true)
      }
      else {
        resolve(false)
      }
    })
  }

  MoveToHistoryProc(tran, lngSupSeq): Promise<number> {


    this.invoiceService.inv_history = new InvHistoryModel(0, lngSupSeq, this.invoiceService.inv_otherdata.lngInvNo, tran.pet_no, this.clinic_no, tran.done_date, tran.appr_date, this.invoiceService.getCurrentDateTime(), tran.link_no, tran.link_type, tran.cost, tran.unit, tran.response1, tran.response2, tran.req_by, tran.done_by, tran.appr_by, this.client_no, tran.route, 0, tran.location, this.client_no)
    if (lngSupSeq == 0) {
      this.invoiceService.inv_history.display = 1
    }
    else {
      this.invoiceService.inv_history.display = tran.pstatus
    }

    return this.invoiceService.SetupInvHistory().then((res: number) => {
      return res
    })
  }

  async UpdateBriefHist(tran) {
    const res = await this.invoiceService.GetBriefHistoryCategory(tran.link_no, tran.link_type, tran.code_clinic);
    if (res === '') {
      console.log('exited')
      return false; // Exit the function
    }

    this.invoiceService.UpdateBriefHist(tran.pet_no, tran.link_no, tran.link_type, tran.code_clinic, tran.client_no, tran.code_name,
      tran.done_date, tran.response1, tran.response2).then(() => {
        this.petService.getBriefByPetId(tran.pet_no);
      })

  }

  async MoveToDrugNote(tran) {
    const res: any = await this.invoiceService.GetTempPrescBySeq(tran.tran_sequence);
    let blnIsRefill = false
    let strTemp = ''

    if (res.pet_no == 0) {
      console.log('empty res exit')
      return false; // Exit the function 
    }

    if (res.pet_no != 0) {
      this.invoiceService.SetupMoveToDrugNote(tran.tran_sequence, tran.done_date)
      blnIsRefill = false
    }

    if (!blnIsRefill) {
      strTemp = res.product_name
    }
    else {
      strTemp = tran.code_name
    }

    this.invoiceService.InsertToDrugNote(res.pet_no, tran.done_date, strTemp, res.doctor, res.units, res.package,
      res.refill_count, res.refill_expire, res.allow_generic, res.instructions, res.in_clinic, res.use_for, tran.unit)

  }

  async MoveToHistoryChild(tran, lngHistSeq) {
    let tmptran: any = await this.invoiceService.GetTmpInvoiceTrans(tran.tran_sequence)

    if (!tmptran) {
      return false;
    }

    tmptran.sup_sequence = lngHistSeq

    tmptran.forEach(async (item) => {
      if (item.status != 'S') {
        const lngSupSeq = await this.MoveToHistoryProc(item, lngHistSeq)
        if (lngSupSeq != 0) {

          this.invoiceService.UpdateTransMoved(item.cod)

          const code = this.catalogService.codes_file.find(codes => codes.code_no === item.link_no);

          if (code.code_name == 'EUTH') {
            if (this.clinic_no == 1) {
              this.invoiceService.UpdateEuthToInactive(item.pet_no)
            }
          }

          item.sup_sequence = lngSupSeq
          this.UpdateBriefHist(item)
          this.MoveSubTran(item.tran_sequence, lngSupSeq)

        }
      }
    })
  }

  MoveSubTran(tran_seq, sup_seq) {
    this.invoiceService.GetInvSubTran(tran_seq).then((item: any) => {
      if (item) {
        item.forEach((subtran) => {
          this.invoiceService.InsertSubTran(sup_seq, subtran.sub_tran_link_no, subtran.sub_tran_link_type, subtran.sub_tran_unit)
        })
      }
    })
  }

  MoveToSuggested(tran) {
    const code = this.catalogService.codes_file.find(codes => codes.code_no === tran.link_no);
    const vnote_text = "Suggested, but declined: " + code.procedure_desc + " (" + tran.code_name + ").     -- " + tran.req_by
    this.invoiceService.MoveToSuggested(tran.pet_no, tran.req_date, tran.link_no, tran.link_type, tran.tran_sequence, tran.req_date, vnote_text)
  }

  //#endregion

  //#region Button & Checkbox functions
  sampleClick() {
    this.openCardPay()
  }

  toggleAllItems(event: any) {
    const checked = event.target.checked;
    this.deletetran_question.forEach(item => {
      item.selected = checked;
    });
  }

  areAllItemsSelected(): boolean {
    return this.deletetran_question.length > 0 &&
      this.deletetran_question.every(item => item.selected);
  }

  toggleStatusItems(status: string, event: any) {
    const checked = event.target.checked;
    this.deletetran_question.forEach(item => {
      if (item.status === status) {
        item.selected = checked;
      }
    });
  }

  backToInvoice() {
    this.router.navigate(['../invoice'], { relativeTo: this.route });
  }

  backToHome() {
    const COUNTDOWN_SEC = 5;

    const navigate = () => {
      this.menuService.setRole(Number(this.invoiceService.userData.role_no));
      this.menuService.setNo(124);
      this.menuService.getSideBarMenu().then(() => {
        this.router.navigate([this.menuService.menu[0].route]);
      });
    };

    let timerInterval: any;

    Swal.fire({
      title: 'Invoiced Successfully.',
      html: `Returning to home in <b>${COUNTDOWN_SEC}</b> second(s)...`,
      icon: 'success',
      timer: COUNTDOWN_SEC * 3000,
      timerProgressBar: true,
      showConfirmButton: true,
      confirmButtonText: 'Done',
      allowOutsideClick: false,
      didOpen: () => {
        let remaining = COUNTDOWN_SEC;
        timerInterval = setInterval(() => {
          remaining--;
          const b = Swal.getHtmlContainer()?.querySelector('b');
          if (b) b.textContent = String(remaining);
        }, 3000);
      },
      willClose: () => {
        clearInterval(timerInterval);
      }
    }).then(() => {
      navigate();
    });
  }

  openCardPay() {
    $('#modalCardPay').modal('show');
  }
  //#endregion Button & Checkbox functions

  //#region Rabies Vaccine   
  selectRabiesVaccine(index: number) {
  }

  openActiveRabiesVaccine() {
    this.invoiceService.selectedActiveRabiesVaccine = new RabiesVaccineModel('', '', '', '', true, '');
    $('#modalActiveRabiesVaccine').modal('toggle');
  }
  //#endregion Rabies Vaccine










}





